var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dialog-edit-address'),_c('address-form',{attrs:{"address":_vm.address,"read_only":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }